import { hooks, Base, Button, Text, TextProps } from '@bitrise/bitkit';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import { trackEvent } from '../../../../utils/tracking';

const { useCopyToClipboard } = hooks;

interface Props extends TextProps {
  bash?: boolean;
  children: string;
  copy?: boolean;
}

const GuideCodeLine: FunctionComponent<Props> = (props) => {
  const { bash, children, copy, weight, ...rest } = props;
  const [ref] = useCopyToClipboard();

  const classes = classnames('GuideCode__line', {
    'GuideCode__line--copy': copy,
  });

  const handleTrackCopyAction = () => {
    if (copy && children) {
      trackEvent('Onboarding.Setup.Copy', { content: children });
    }
  };

  return (
    <Text
      {...rest}
      borderRadius="x1"
      className={classes}
      container
      data-clipboard-text={copy ? children : undefined}
      innerRef={copy ? ref : undefined}
      paddingHorizontal="x2"
      paddingVertical="x1"
    >
      <Text className="GuideCode__line-text">
        <Text config="8" textColor={weight === 'bold' ? 'gray-8' : undefined} weight={weight}>
          {bash && (
            <Text inline style={{ userSelect: 'none' }}>
              ${' '}
            </Text>
          )}
          {children}
        </Text>
      </Text>

      <Base className="GuideCode__clipboard">
        <Button elevation="x2" onClick={handleTrackCopyAction} size="small">
          Copy to clipboard
        </Button>
      </Base>
    </Text>
  );
};

export default GuideCodeLine;
